import { useState } from "react";
import API from "../api/api";
import logo from "../assets/logo2.png";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
const [stayLoggedIn, setStayLoggedIn] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await API.post("/auth/login", {
    email,
    password,
    rememberMe: stayLoggedIn
});

            const { token, user } = res.data;

// Clear any previous login from both storage locations
localStorage.removeItem("token");
localStorage.removeItem("role");
localStorage.removeItem("user");

sessionStorage.removeItem("token");
sessionStorage.removeItem("role");
sessionStorage.removeItem("user");

// Store the new login in the selected storage
const storage = stayLoggedIn ? localStorage : sessionStorage;

storage.setItem("token", token);
storage.setItem("role", user.role);
storage.setItem("user", JSON.stringify(user));

            // redirect based on role
            if (user.role === "admin") {
                window.location.href = "/";
            } else if (user.role === "guide") {
                window.location.href = "/guide";
            } else {
                window.location.href = "/";
            }

        } catch (err) {
            alert(err.response?.data?.error || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#c75028"
        }}>
            <div style={{
                width: "380px",
                padding: "30px",
                borderRadius: "12px",
                background: "white",
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
            }}>

                {/* LOGO */}
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "1px" , marginTop: "-15px"}}>
                    <img
                        src={logo}
                        alt="Paris Unscripted"
                        style={{ width: "360px", objectFit: "contain" }}
                    />
                </div>

                <h2 style={{ textAlign: "center", marginBottom: "20px", marginTop: "-25px" }}>
                    Login
                </h2>

                <form
                    onSubmit={handleLogin}
                    style={{ display: "flex", flexDirection: "column", gap: "12px" }}
                >
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{
                            padding: "12px",
                            borderRadius: "8px",
                            border: "1px solid #ccc"
                        }}
                    />

                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                            padding: "12px",
                            borderRadius: "8px",
                            border: "1px solid #ccc"
                        }}
                    />

                    <label
    style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "14px",
        color: "#475569",
        cursor: "pointer"
    }}
>
    <input
        type="checkbox"
        checked={stayLoggedIn}
        onChange={(e) => setStayLoggedIn(e.target.checked)}
        style={{
            width: "16px",
            height: "16px",
            cursor: "pointer"
        }}
    />

    Stay logged in
</label>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            padding: "12px",
                            borderRadius: "8px",
                            border: "none",
                            background: "#F97316",
                            color: "white",
                            cursor: "pointer",
                            fontWeight: "bold"
                        }}
                    >
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
}